// The regular PDP's source is app--429812416513.launch_availability, not the
// old Restock Rocket shipping_text fields. Resolve the exact variant and market.
window.UrbanGiftingShipping = (() => {
  const validDate=value=>typeof value==='string' && /^\d{4}-\d{2}-\d{2}$/.test(value) && Number.isFinite(Date.parse(value+'T00:00:00Z')) && new Date(value+'T00:00:00Z').toISOString().slice(0,10)===value;
  function notice(product,variant,country=product?.countryCode || 'US',now=Date.now()) {
    if(!product || !variant)return '';
    const policy=String(variant.inventoryPolicy || '').toLowerCase();
    const data=product.preorder;
    // Description text is already customer-facing even when ordering is closed.
    if(!data){
      const html=product.description || '',paragraphs=html.match(/<(?:p|div|li)\b[^>]*>[\s\S]*?<\/(?:p|div|li)>/gi) || [html];
      const note=paragraphs.map(p=>p.replace(/<[^>]*>/g,' ').replace(/&nbsp;/gi,' ').replace(/&amp;/gi,'&').replace(/\s+/g,' ').trim()).find(text=>/\bpre[ -]?order\b/i.test(text) && /\bship(?:ping|s)?\b/i.test(text));if(note)return note;
    }
    if(policy!=='continue')return '';
    const market=country==='JP'?'JP':'US',key=String(variant.id).split('/').pop(),entry=data?.variants?.[key]?.[market];
    if(data && data.version!==1)return 'Shipping timing is being confirmed.';
    if(entry?.enabled===true && (!Number.isFinite(Date.parse(entry.expiresAt)) || !validDate(entry.shippingDate)))return 'Shipping timing is being confirmed.';
    if(data?.version===1 && entry?.enabled===true && Date.parse(entry.expiresAt)>now && validDate(entry.shippingDate)) {
      const date=new Intl.DateTimeFormat(product.locale || 'en-US',{month:'long',day:'numeric',timeZone:'UTC'}).format(new Date(entry.shippingDate+'T00:00:00Z'));
      return `${entry.scope==='product'?'Pre-order':'This option is on pre-order'} · Expected to ship ${date}.`;
    }
    if(!Object.prototype.hasOwnProperty.call(product,'preorder'))return 'Shipping timing is being confirmed.';
    return (market==='JP'?variant.jpAvailable:variant.usAvailable)===false ? 'Expected back in stock within a few days.' : '';
  }
  function summary(product,variants=product?.variants || [],country,now) {
    const notes=variants.map(v=>notice(product,v,country,now));
    const unique=[...new Set(notes.filter(Boolean))];
    return unique.length===1 && notes.every(Boolean)?unique[0]:unique.length?'Shipping timing varies by option. Check options.':'';
  }
  function watchExpiry(products,onExpiry,{now=()=>Date.now(),setTimer=setTimeout,clearTimer=clearTimeout}={}) {
    let timer,stopped=false;
    function schedule(){
      clearTimer(timer);
      if(stopped)return;
      const current=now();let next=Infinity;
      for(const product of products)for(const markets of Object.values(product.preorder?.variants || {}))for(const entry of Object.values(markets || {})){
        const expiry=entry?.enabled===true ? Date.parse(entry.expiresAt) : NaN;
        if(Number.isFinite(expiry)&&expiry>current&&expiry<next)next=expiry;
      }
      if(next!==Infinity)timer=setTimer(()=>{if(stopped)return;if(now()>=next)onExpiry();schedule();},Math.max(1,Math.min(2147483647,next-current+1)));
    }
    schedule();
    return {refresh(){if(!stopped){onExpiry();schedule();}},stop(){stopped=true;clearTimer(timer);}};
  }
  return {notice,summary,watchExpiry};
})();
